import {Component, OnDestroy, OnInit, signal} from '@angular/core';
import {RouterLink} from '@angular/router';
import {User} from '../../classes/user.class';
import {UserAssignment} from '../../classes/user-assignment.class';
import {UserService} from '../../services/user/user.service';
import {MatButton} from '@angular/material/button';
import {CodaltComponent} from '../../codalt.component';
import {Routenames} from '../../classes/route-name.enum';
import {BreadcrumbComponent} from '../../services/breadcrumb/breadcrumb.component';
import {DatePipe, DecimalPipe} from '@angular/common';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-users-overview',
    templateUrl: './users-overview.component.html',
    styleUrls: ['./users-overview.component.scss'],
    imports: [
        MatButton,
        RouterLink,
        BreadcrumbComponent,
        DatePipe,
        DecimalPipe,
    ]
})
export class UsersOverviewComponent extends CodaltComponent implements OnInit, OnDestroy {

    readonly users = signal<User[]>(null);
    readonly UserAssignment = UserAssignment;

    constructor(
        private titleService: Title,
        private userService: UserService,
    ) {
        super();
        this.crumbs = [
            {name: 'Gebruikers', route: Routenames.users}
        ];
        this.titleService.setTitle(`Gebruikers ${this.environment.titleAppend}`);
    }

    ngOnInit() {
        this.subscriptions.add(
            this.userService.getList().subscribe(users => {
                const sortedUsers = users.sort((a, b) =>
                    new Date(a.employment_end).getTime() - new Date(b.employment_end).getTime() ||
                    new Date(a.employment_start).getTime() - new Date(b.employment_start).getTime()
                );
                this.users.set(sortedUsers)
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
